﻿import { debounce, parseOptions } from './utils';

const selector = '[data-count]';
const characterCountAttribute = 'data-characters-count';

type Direction = '<' | '<=' | '>=' | '>';
interface Options {
  direction: Direction;
  limit: number;
  limitClass: string;
  hardLimit: boolean;
  delay: number;
}

const defaultOptions: Options = {
  direction: '>=',
  limit: 250,
  limitClass: 'limit-reached',
  hardLimit: false,
  delay: 100
};

const nodes = document.querySelectorAll(selector);

nodes.forEach((el) => {
  const input = el as HTMLInputElement | HTMLTextAreaElement;
  const raw = input.dataset?.count ?? null;

  const options = parseOptions<Options>(raw, defaultOptions);

  // ensure proper types for numeric/boolean values (parseOptions already attempts coercion)
  options.limit = Number(options.limit ?? defaultOptions.limit);
  options.delay = Number(options.delay ?? defaultOptions.delay);
  options.hardLimit = Boolean(options.hardLimit ?? defaultOptions.hardLimit);

  const parent = input.parentElement;
  if (!parent) return;

  updateCount(parent, input, options);

  const handler = debounce(() => {
    updateCount(parent, input, options);
  }, options.delay);

  // use input to capture typing, paste and other changes
  input.addEventListener('input', handler);
  // keep keyup for compatibility if needed
  input.addEventListener('keyup', handler);
});

function updateCount(
  parent: Element,
  input: HTMLInputElement | HTMLTextAreaElement,
  options: Options
) {
  let charactersCount = (input.value ?? '').length;

  if (options.hardLimit && options.limit > 0 && charactersCount > options.limit) {
    input.value = input.value.substring(0, options.limit);
    charactersCount = input.value.length;
  }

  parent.setAttribute(characterCountAttribute, `${charactersCount}/${options.limit}`);

  let force = false;
  switch (options.direction) {
    case '<':
      force = charactersCount < options.limit;
      break;
    case '<=':
      force = charactersCount <= options.limit;
      break;
    case '>=':
      force = charactersCount >= options.limit;
      break;
    case '>':
      force = charactersCount > options.limit;
      break;
    default:
      force = false;
  }

  parent.classList.toggle(options.limitClass, force);
}
